
export enum CompetencyMatrixSettingsHighlight {
	Awarded = 'Awarded',
	NotAwarded = 'NotAwarded',
	AwardedAndNotExpired = 'AwardedAndNotExpired',
	AwardedAndExpired = 'AwardedAndExpired'
}
